module["exports"] = [
  "Inc",
  "and Sons",
  "LLC",
  "Group"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pl/company/suffix.js
 ** module id = 846
 ** module chunks = 0
 **/